import { Link, Route, Routes } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { RotaComBonusPrompts } from '@/auth/RotaComBonus';
import { RotaDeCriacao } from '@/auth/RotaDeCriacao';
import { RotaDoEditorDeDocumentos } from '@/auth/RotaDoEditorDeDocumentos';
import { RotaProtegida } from '@/auth/RotaProtegida';
import { Admin } from '@/paginas/Admin';
import { Biblioteca } from '@/paginas/Biblioteca';
import { CriarConta, Entrar, EsqueciSenha, RedefinirSenha } from '@/paginas/Autenticacao';
import { Convite } from '@/paginas/Convite';
import { Contato } from '@/paginas/Contato';
import { Demo } from '@/paginas/Demo';
import { Documentos } from '@/paginas/Documentos';
import { Escrever } from '@/paginas/Escrever';
import { EditorDocumento } from '@/paginas/EditorDocumento';
import { EditorMiolo } from '@/paginas/EditorMiolo';
import { Inicio } from '@/paginas/Inicio';
import { Impressao } from '@/paginas/Impressao';
import { MeusMiolos } from '@/paginas/MeusMiolos';
import { MinhaConta } from '@/paginas/MinhaConta';
import { Modelos } from '@/paginas/Modelos';
import { Apresentacao } from '@/paginas/Apresentacao';
import { Texto } from '@/paginas/Texto';
import { Textos } from '@/paginas/Textos';
import { Trabalho } from '@/paginas/Trabalho';
import { Mockup } from '@/paginas/Mockup';
import { Planos } from '@/paginas/Planos';
import { Prompts } from '@/paginas/Prompts';
import { VerMiolo } from '@/paginas/VerMiolo';
import { Button } from '@/components/ui/button';

function NaoEncontrado() {
  return (
    <div className="mx-auto max-w-md space-y-3 py-20 text-center">
      <p className="font-mono text-4xl font-semibold text-primary/30">404</p>
      <h1 className="text-lg font-semibold">Página não encontrada</h1>
      <p className="text-sm text-muted-foreground">
        O endereço acessado não existe. Talvez o miolo tenha sido excluído.
      </p>
      <Button asChild variant="contorno">
        <Link to="/">Voltar para o início</Link>
      </Button>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      {/*
       * Imagem de divulgação: rota **fora** do site de propósito.
       *
       * O que sai daqui é uma foto — e foto com cabeçalho de menu no topo não
       * serve. Tirando a rota do `Layout`, a cena ocupa a página inteira sem
       * depender de media query de impressão.
       */}
      <Route path="mockup/:id" element={<Mockup />} />

      <Route element={<Layout />}>
        <Route index element={<Inicio />} />
        <Route path="entrar" element={<Entrar />} />
        <Route path="criar-conta" element={<CriarConta />} />
        {/* Recuperação de senha: pedir o link e trocar a senha. */}
        <Route path="esqueci-senha" element={<EsqueciSenha />} />
        <Route path="redefinir-senha/:codigo" element={<RedefinirSenha />} />
        <Route path="demo" element={<Demo />} />
        <Route path="modelos" element={<Modelos />} />
        <Route path="planos" element={<Planos />} />
        {/* A área de quem escreve: o editor de documentos com porta própria. */}
        <Route path="escrever" element={<Escrever />} />

        {/* Convite de teste de um módulo (miolos ou documentos). */}
        {/* Biblioteca de trabalhos: o resumo é aberto, o texto tem consulta. */}
        <Route path="biblioteca" element={<Biblioteca />} />
        <Route path="biblioteca/:id" element={<Trabalho />} />
        <Route path="convidar/:codigo" element={<Convite />} />

        {/* Contato com o desenvolvedor: sugestões e pedidos. */}
        <Route path="contato" element={<Contato />} />

        {/*
          Impressão avulsa: rota pública, protegida por token de uso único.
          Quem abre é o Chromium do servidor, ao gerar o PDF do miolo.
        */}
        <Route path="imprimir/:id" element={<Impressao />} />

        <Route
          path="admin"
          element={
            <RotaProtegida>
              <Admin />
            </RotaProtegida>
          }
        />

        <Route
          path="criar"
          element={
            <RotaDeCriacao>
              <EditorMiolo />
            </RotaDeCriacao>
          }
        />
        <Route
          path="miolos/:id/editar"
          element={
            <RotaProtegida>
              <EditorMiolo />
            </RotaProtegida>
          }
        />
        <Route
          path="miolos/:id"
          element={
            <RotaProtegida>
              <VerMiolo />
            </RotaProtegida>
          }
        />
        <Route
          path="textos"
          element={
            <RotaProtegida>
              <Textos />
            </RotaProtegida>
          }
        />
        <Route
          path="textos/:id"
          element={
            <RotaProtegida>
              <Texto />
            </RotaProtegida>
          }
        />
        <Route
          path="textos/:id/apresentar"
          element={
            <RotaProtegida>
              <Apresentacao />
            </RotaProtegida>
          }
        />
        <Route
          path="meus-miolos"
          element={
            <RotaProtegida>
              <MeusMiolos />
            </RotaProtegida>
          }
        />

        <Route
          path="documentos"
          element={
            <RotaDoEditorDeDocumentos>
              <Documentos />
            </RotaDoEditorDeDocumentos>
          }
        />
        <Route
          path="documentos/:id"
          element={
            <RotaDoEditorDeDocumentos>
              <EditorDocumento />
            </RotaDoEditorDeDocumentos>
          }
        />

        <Route
          path="conta"
          element={
            <RotaProtegida>
              <MinhaConta />
            </RotaProtegida>
          }
        />

        <Route
          path="prompts"
          element={
            <RotaComBonusPrompts>
              <Prompts />
            </RotaComBonusPrompts>
          }
        />

        <Route path="*" element={<NaoEncontrado />} />
      </Route>
    </Routes>
  );
}
